module.exports = __webpack_public_path__ + "img/logo2.c4e0244d.png";